import { render, staticRenderFns } from "./FileUpload.vue?vue&type=template&id=0d05a5ef&scoped=true&"
import script from "./FileUpload.vue?vue&type=script&lang=js&"
export * from "./FileUpload.vue?vue&type=script&lang=js&"
import style0 from "./FileUpload.vue?vue&type=style&index=0&id=0d05a5ef&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d05a5ef",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\workspace\\uat\\platform-uat\\Platform-foundation-pc\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0d05a5ef')) {
      api.createRecord('0d05a5ef', component.options)
    } else {
      api.reload('0d05a5ef', component.options)
    }
    module.hot.accept("./FileUpload.vue?vue&type=template&id=0d05a5ef&scoped=true&", function () {
      api.rerender('0d05a5ef', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/FileUpload/FileUpload.vue"
export default component.exports